import { Offer, Voucher, ConfiguredOffers } from 'features/vouchers/types'

export const isAppliedOffer = (offer: Offer, appliedOffers: Voucher[]): boolean =>
  !!appliedOffers.find(
    (appliedOffer) => appliedOffer.offerPropositionId === offer.offerPropositionId,
  )

export const getExtendedOfferInfo = (
  offer: Offer,
  configuredOffers: ConfiguredOffers[],
): ConfiguredOffers | undefined => {
  return configuredOffers?.find(
    (configuredOffer: ConfiguredOffers): boolean => configuredOffer?.key === offer.offerKey,
  )
}
